<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-tooltip
          top
          color="primary"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="urlAliasLocale"
              v-bind="attrs"
              dense
              outlined
              label="URL"
              readonly
              disabled
              :loading="loading"
              :rules="[!isUrlRequired || ((v) => (!!v && v.length <= 100) || 'Máximo de 100 caracteres')]"
              v-on="on"
            />
          </template>

          <span>Esta URL é definida automaticamente usando o nome da empresa e deste canal</span>
        </v-tooltip>
      </v-col>

      <!-- <v-col
        cols="12"
        sm="3"
      >
        <v-text-field
          v-model="dns1Locale"
          dense
          outlined
          label="DNS 1"
          validate-on-blur
          readonly
          disabled
          :loading="loading"
          :rules="[!isDnsRequired || ((v) => (!!v && v.length <= 100) || 'Máximo de 100 caracteres')]"
          @change="v => $emit('update:dns1', v)"
        />
      </v-col>

      <v-col
        cols="12"
        sm="2"
      >
        <v-text-field
          v-model="dns2Locale"
          dense
          outlined
          label="DNS 2"
          validate-on-blur
          disabled
          :loading="loading"
          :rules="[!isDnsRequired || ((v) => (!!v && v.length <= 100) || 'Máximo de 100 caracteres')]"
          @change="v => $emit('update:dns2', v)"
        />
      </v-col> -->
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="3"
        class="d-flex align-center justify-center"
      >
        <v-avatar
          rounded
          size="160"
        >
          <v-img
            :src="logoDataUrlLocale"
            contain
          />
        </v-avatar>

        <div class="d-flex flex-column align-center justify-center ml-3">
          <v-btn
            icon
            color="primary"
            class="mb-2"
          >
            <v-icon
              size="40"
              @click="inputLogotipoRef.click()"
            >
              {{ icons.mdiPlus }}
            </v-icon>
          </v-btn>

          <v-btn
            icon
            color="error"
          >
            <v-icon
              size="40"
              @click="descartarFotoUpload"
            >
              {{ icons.mdiTrashCanOutline }}
            </v-icon>
          </v-btn>
        </div>

        <input
          ref="inputLogotipoRef"
          type="file"
          accept=".png, .jpg, .jpeg"
          hidden
          @change="parseFotoUpload"
        />
      </v-col>

      <v-col
        cols="12"
        md="9"
      >
        <v-text-field
          v-model="tituloHeaderLocale"
          class="mb-2"
          dense
          outlined
          label="Título página"
          validate-on-blur
          :loading="loading"
          :rules="[(v) => (!v || v.length <= 60) || 'Máximo de 60 caracteres']"
          @change="v => $emit('update:tituloHeader', v)"
        />

        <v-textarea
          v-model="headerHtmlLocale"
          class="mb-2"
          dense
          outlined
          auto-grow
          label="Header HTML Página"
          validate-on-blur
          :loading="loading"
          :rules="[(v) => (!v || v.length <= 1000) || 'Máximo de 1000 caracteres']"
          @change="v => $emit('update:headerHtml', v)"
        />

        <v-textarea
          v-model="footerHtmlLocale"
          dense
          outlined
          auto-grow
          label="Footer HTML Página"
          validate-on-blur
          :loading="loading"
          :rules="[(v) => (!v || v.length <= 1000) || 'Máximo de 1000 caracteres']"
          @change="v => $emit('update:footerHtml', v)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { ref, watch, computed } from '@vue/composition-api'
import { mdiPlus, mdiTrashCanOutline } from '@mdi/js'
import { required } from '@core/utils/validation'

export default {
  emits: ['update:dns1', 'update:dns2', 'update:tituloHeader', 'update:headerHtml', 'update:footerHtml', 'getLogoDataUrl'],

  props: {
    canalData: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const urlLocale = ref(null)
    const dns1Locale = ref(null)
    const dns2Locale = ref(null)
    const tituloHeaderLocale = ref(null)
    const headerHtmlLocale = ref(null)
    const footerHtmlLocale = ref(null)
    const urlAliasLocale = ref(null)

    const isDialogOpen = ref(false)

    const logoDataUrlLocale = ref(require('@/assets/images/avatars/avatar_user.png'))
    const antigaLogotipo = ref(require('@/assets/images/avatars/avatar_user.png'))
    const inputLogotipoRef = ref(null)

    const isUrlRequired = computed(() => !!dns1Locale.value || !!dns2Locale.value)
    const isDnsRequired = computed(() => (!!dns1Locale.value || !!dns2Locale.value) || !!urlLocale.value)

    watch(
      () => props.canalData,
      v => {
        urlLocale.value = v?.url || null
        dns1Locale.value = v?.dns1 || null
        dns2Locale.value = v?.dns2 || null
        tituloHeaderLocale.value = v?.tituloHeader || null
        headerHtmlLocale.value = v?.headerHtml || null
        footerHtmlLocale.value = v?.footerHtml || null
        urlAliasLocale.value = v?.urlAlias || null
        logoDataUrlLocale.value = v?.logoDataUrl || require('@/assets/images/avatars/avatar_user.png')
        antigaLogotipo.value = require('@/assets/images/avatars/avatar_user.png')
      },
      { immediate: true },
    )

    function descartarFotoUpload() {
      logoDataUrlLocale.value = antigaLogotipo.value
      isDialogOpen.value = false
      emit('getLogoDataUrl', null)
    }
    function parseFotoUpload(e) {
      const file = e.target.files[0]
      const reader = new FileReader()

      reader.onloadend = () => {
        const dataUrl = reader.result
        const tamanhoImagemEmMB = new Blob([dataUrl]).size / 1_048_576

        if (tamanhoImagemEmMB > 1) {
          Vue.$toast.warning('A imagem não pode ter mais de 1MB.', { timeout: false })
        } else {
          antigaLogotipo.value = logoDataUrlLocale.value
          logoDataUrlLocale.value = dataUrl
          emit('getLogoDataUrl', dataUrl)
        }
      }
      reader.readAsDataURL(file)
    }

    return {
      urlLocale,
      dns1Locale,
      dns2Locale,
      tituloHeaderLocale,
      headerHtmlLocale,
      footerHtmlLocale,
      urlAliasLocale,

      isDialogOpen,

      inputLogotipoRef,
      logoDataUrlLocale,

      isUrlRequired,
      isDnsRequired,

      parseFotoUpload,
      descartarFotoUpload,

      validators: {
        required,
      },
      icons: {
        mdiPlus,
        mdiTrashCanOutline,
      },
    }
  },
}
</script>
